import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ImagePreviewDialogProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
  productName: string;
  productBrand?: string;
}

export function ImagePreviewDialog({
  open,
  onClose,
  imageUrl,
  productName,
  productBrand,
}: ImagePreviewDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            {productBrand ? `${productBrand} - ` : ""}{productName}
          </DialogTitle>
        </DialogHeader>
        <div className="flex items-center justify-center">
          <img
            src={imageUrl}
            alt={productName}
            className="max-h-[70vh] w-auto rounded-lg"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
